module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "home-header"
    }
  }, [_c('div', {
    attrs: {
      "id": "fullpage-main"
    }
  }, [_c('div', {
    staticClass: "section overlay-container text-center d-flex align-items-center",
    style: ('background-image: url(' + _vm.slides[0] + ')'),
    attrs: {
      "id": "home"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "section white",
    style: ('background-image: url(' + _vm.slides[1] + ')'),
    attrs: {
      "id": "features"
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "section white overlay-container text-center",
    style: ('background-image: url(' + _vm.slides[4] + ')'),
    attrs: {
      "id": "contact_us"
    }
  }, [_vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10 mx-auto"
  }, [_c('h2', {
    staticClass: "text-xxl text-light font-2 white"
  }, [_vm._v("Maximize your cabana revenue!")]), _vm._v(" "), _c('p', {
    staticClass: "text-l font-2 white"
  }, [_vm._v("Inventory and Reservation Management | Automated Dynamic Pricing | Real-time Accounting and Reporting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container content box-middle"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', {
    staticClass: "text-l text-light font-2 white"
  }, [_vm._v("Features & Benefits")]), _vm._v(" "), _c('div', {
    staticClass: "divider white"
  }), _vm._v(" "), _c('ul', {
    staticClass: "text-m"
  }, [_c('li', [_vm._v("Capture cabana reservations via the OpenCabana website or mobile application, an embeddable widget that can added to your hotels website")]), _vm._v(" "), _c('li', [_vm._v("Know which cabanas are available in real-time and receive alerts when cabanas are turned over")]), _vm._v(" "), _c('li', [_vm._v("Avoid under-the-table and unauthorized cabana rentals by staff")]), _vm._v(" "), _c('li', [_vm._v("Price your cabanas based on location, date range or occupancy levels")]), _vm._v(" "), _c('li', [_vm._v("Get text or email alerts for comps or discounts and no-shows or cancellations")]), _vm._v(" "), _c('li', [_vm._v("Auto-generate and send email and text discount offers")]), _vm._v(" "), _c('li', [_vm._v("Waitlist option with availability notifications")]), _vm._v(" "), _c('li', [_vm._v("Monitor sales in real-time and generate guest activity and revenue reports")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', {
    staticClass: "text-l text-light font-2 white"
  }, [_vm._v("Easy Setup & Minimal Training")]), _vm._v(" "), _c('div', {
    staticClass: "divider white"
  }), _vm._v(" "), _c('ul', {
    staticClass: "text-m"
  }, [_c('li', [_vm._v("No access to any hotel systems needed")]), _vm._v(" "), _c('li', [_vm._v("Minimal tech skills and staff training required")]), _vm._v(" "), _c('li', [_vm._v("OpenCabana is a software as a service (SaaS) solution requiring no software installation and can on your existing computers")]), _vm._v(" "), _c('li', [_vm._v("No need for a POS system. OpenCabana’s mobile checkin tablets can process payments and directly deposit payments into your hotels operating account instantly")]), _vm._v(" "), _c('li', [_vm._v("You only pay for usage based on the number of reservations managed through the system")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container content box-middle"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('p', {
    staticClass: "text-xl font-2 white margin-bottom"
  }, [_vm._v("Schedule a 15 minute demo!")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "text-l font-2 white"
  }, [_vm._v("OpenCabana, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "font-2 text-m"
  }, [_vm._v("\n                                  1616 SE 8th Street,"), _c('br'), _vm._v("\n                                  Fort Lauderdale, Florida 33316"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "text-l font-2 white"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('p', {
    staticClass: "font-2 text-m"
  }, [_vm._v("(+1) 954-300-4445"), _c('br'), _vm._v("\n                            corp@opencabana.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-733a9c65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/index.vue
// module id = 602
// module chunks = 2